import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelVr.mjs'

export const FormItemIp = props => (
    <FormItemBizProp
        Model={Model}
        prop="ip"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemVsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="vsName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseVr(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemVsName />
            <FormItemIp />
        </FormChooseDesign>
    )
}
